export default __webpack_public_path__ + "static/media/globeautenticationweb.3d842c08.png";